<template>
  <div class="alert">
    <v-alert v-for="(alert, index) in alerts" :key="index" :type="alert.type">
      {{ $t(alert.code) }}
    </v-alert>
  </div>
</template>

<script>
export default {
  computed: {
    alerts() {
      return this.$store.getters["alerts/alerts"];
    }
  }
};
</script>

<style scoped>
.alert {
  position: absolute;
  width: 400px;

  top: 0;
  right: 0;

  margin-top: 10px;
  margin-right: 10px;
}
</style>
